import { GlobalState } from '@leverege/ui-redux';
import { Context } from '@leverege/plugin';
import { AllowedReducer, Constants } from '@leverege/api-redux';
import { Dialogs } from '@leverege/ui-elements';
import I18N from '@leverege/i18n';
import checkForLostRecords from '../../util/Lost';
import MarkAsFoundDialog from './MarkAsFoundDialog';
const {
  t
} = I18N.ns('recovr.lost.markAsFound.MarkAsFoundAction');
const {
  tIcon
} = I18N.ns('recovr.icons');
const markAsFound = type => ({
  id: `recovr.${type}.markAsFound`,
  name: 'Mark as Found',
  matches: [{
    use: ['contextMenu', 'mobileActionBar'],
    path: type === 'locator' ? `location.${type}s` : `location.${type}`,
    objectType: type
  }, {
    use: ['contextMenu', 'mobileActionBar'],
    path: type === 'locator' ? `${type}` : `${type}`,
    objectType: type
  }, {
    use: ['contextMenu', 'mobileActionBar'],
    path: type === 'locator' ? `company.${type}s` : `company.${type}`,
    objectType: type
  }, {
    use: ['contextMenu', 'mobileActionBar'],
    path: type === 'locator' ? `company.locations.${type}s` : `company.locations.${type}`,
    objectType: type
  }, {
    client: 'MapBoxRolloverSelectionPointer',
    use: ['contextMenu', 'mobileActionBar']
  }],
  isPrepared: cxt => {
    const targets = Context.getTargetsOfType(cxt, type);
    if (targets == null || targets.length === 0) {
      return true;
    }
    const deviceId = targets[0]?.id;
    const a = AllowedReducer.get(GlobalState.get(), deviceId);
    return a.markAsFound != null;
  },
  prepare: async cxt => {
    const targets = Context.getTargetsOfType(cxt, type);
    const locationId = targets[0]?.data?.data?.location?.id;
    const deviceId = targets[0]?.id;
    const a = AllowedReducer.get(GlobalState.get(), deviceId);
    if (a.markAsFound != null) {
      return null;
    }
    return GlobalState.dispatch(async (dispatch, getState, {
      api
    }) => {
      const nApi = api.interface(process.env.SYSTEM_ID, 'location').obj(locationId);
      const res = await nApi.srv('recovr').post('lost/markAsFound', {
        deviceId,
        type
      }, {
        test: true
      });
      dispatch({
        type: Constants.ALLOWED_SET,
        resourceId: deviceId,
        action: 'markAsFound',
        allowed: res.allowed === true
      });
      return res.allowed;
    });
  },
  appearance: props => {
    const context = props?.context?.clientState?.actionsContext || props.context;
    const targets = context.targets || context.target;
    const count = targets.length;
    return {
      name: count > 1 ? t('pluralName', {
        count
      }) : t('name'),
      icon: tIcon('markAsFound'),
      iconOpts: {
        style: {
          fontSize: '16px',
          marginRight: '8px'
        }
      }
    };
  },
  perform: props => {
    const context = props?.context?.clientState?.actionsContext || props.context;
    const targets = Context.getTargetsOfType(context, type);
    if (!targets[0]) {
      return;
    }
    Dialogs.show({
      id: 'markAsFound',
      component: MarkAsFoundDialog,
      props: {
        targets,
        context
      }
    });
  }
});
const markLocatorAsFound = {
  id: 'recovr.locator.markAsFound',
  handles: cxt => {
    const targets = Context.getTargetsOfType(cxt, 'locator');
    if (targets == null || targets.length === 0) {
      return false;
    }
    const a = AllowedReducer.get(GlobalState.get(), targets[0]?.id);
    const {
      isAllLost
    } = checkForLostRecords(targets);
    return a.markAsFound === true && isAllLost;
  },
  ...markAsFound('locator')
};
const markLostAsFound = {
  id: 'recovr.lost.markAsFound',
  handles: cxt => {
    const targets = Context.getTargetsOfType(cxt, 'lost');
    if (targets == null || targets.length === 0) {
      return false;
    }
    const a = AllowedReducer.get(GlobalState.get(), targets[0]?.id);
    const {
      isAllLost
    } = checkForLostRecords(targets);
    return a.markAsFound === true && isAllLost;
  },
  ...markAsFound('lost')
};
export default {
  markLocatorAsFound,
  markLostAsFound
};